import React from "react";
import {useTranslation} from "react-i18next";

const TimeRangePicker = ({startTime, setStartTime, endTime, setEndTime, isDarkMode = false}) => {
    const {t} = useTranslation("activite");
    const handleStartTimeChange = (e) => {
        setStartTime(e.target.value);
    };

    const handleEndTimeChange = (e) => {
        setEndTime(e.target.value);
    };

    return (
        <div className="flex flex-row items-center justify-center py-1 px-4 text-center">
            <div className="flex items-center justify-center">
                <span className={`text-sm md:text-base mr-1 md:mr-2 font-medium ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>{t("timeRangePicker.start")}</span>
                <input
                    type="time"
                    value={startTime}
                    onChange={handleStartTimeChange}
                    className={`border-none text-sm md:text-base font-bold w-[4.5rem] md:w-15 bg-transparent ${isDarkMode ? 'text-gray-200' : 'text-gray-700'}`}
                />
            </div>
            <div className="flex items-center mx-2 md:mx-4">
                <span className={`text-sm md:text-base mr-1 md:mr-2 font-medium ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>{t("timeRangePicker.end")}</span>
                <input
                    type="time"
                    value={endTime}
                    onChange={handleEndTimeChange}
                    className={`border-none text-sm md:text-base font-bold w-[4.5rem] md:w-15 bg-transparent ${isDarkMode ? 'text-gray-200' : 'text-gray-700'}`}
                />
            </div>
        </div>
    );
};

export default TimeRangePicker;
